var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "form-group row granted-amounts-list" },
    [
      _c("plain-text-control", {
        class: [_vm.labelClass, "col-form-label", _vm.bold ? "bold" : ""],
        attrs: { title: _vm.title }
      }),
      _vm._v(" "),
      _c("div", { class: [_vm.valueClass, "form-row-content"] }, [
        _c(
          "ul",
          _vm._l(_vm.yearAmountPairs, function(pair, index) {
            return _c("li", { staticClass: "mb-1" }, [
              _vm._v(_vm._s(pair.year) + " "),
              _c("span", { staticClass: "ml-2 mr-2" }, [_vm._v("-")]),
              _vm._v(" " + _vm._s(_vm._f("formatNumber")(pair.amount)) + " €")
            ])
          }),
          0
        )
      ])
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }